module.exports = __webpack_public_path__ + "img/titleLineLight.42d70319.png";